import { $, pageLoaded } from 'venuescanner-js/tools/elemental';
import { ObserverIntersection } from './intersectionObserver';

const transposers = {
  gallery: filename =>
    window.innerWidth > 800 ? filename.replace(/\/med_/, '/main_') : filename,
};
export const lazyload = {
  imageCount: 0,
  started: false,
  init: function (body) {
    if (typeof window === 'undefined') return;
    if (typeof body === 'undefined') body = document.body;
    // console.log('lazyload', body)
    $(body)
      .find('noscript[noscript-data-src]')
      .get()
      .forEach(noscript => {
        let img = $('<img>');
        let $noscript = $(noscript);
        img.attr('data-src', $noscript.attr('noscript-data-src'));
        img.attr('alt', $noscript.attr('alt'));
        img.attr(
          'scoller-detect-parent',
          $noscript.attr('scoller-detect-parent'),
        );
        img.attr('transposer', $noscript.attr('transposer'));

        if ($noscript.attr('ga-action'))
          img.attr('ga-action', $noscript.attr('ga-action'));
        noscript.parentNode.insertBefore(img.get(0), noscript);
        $noscript.remove();
      });

    $(body)
      .find('*[data-src]:not(.lazyload):not([data-skip="skip"])')
      .addClass('lazyload')
      .forEach(e => {
        $(e).addClass('lazyload');
        if (e.tagName === 'IMG' || e.getAttribute('scoller-detect-parent')) {
          ObserverIntersection(e.parentElement, {
            method: () => {
              lazyload.load(e);
            },
            onlyOnce: true,
          });
        } else {
          ObserverIntersection(e, {
            method: () => {
              lazyload.load(e);
            },
            onlyOnce: true,
          });
        }
      });

    this.started = true;
  },

  load: function (e) {
    let src = e.getAttribute('data-src');
    if (!src) return;

    let transposer = e.getAttribute('transposer');
    let rename = filename => filename;
    if (transposer && transposers[transposer]) rename = transposers[transposer];

    if (e.tagName === 'IMG') {
      $(e)
        .bind('load', function () {
          $(this).removeClass('lazyload').parent().removeClass('loading');
          if (e.blurPanel !== undefined) {
            e.blurPanel
              .css({
                backgroundImage: 'url("' + e.src + '")',
              })
              .addClass('lazyload-loaded');
          }
        })
        .parent()
        .addClass('loading');
      e.src = rename(src);
    } else {
      let img = document.createElement('img');
      $(img).bind('load', function () {
        $(e)
          .removeClass('lazyload')
          .removeClass('loading')
          .css({
            backgroundImage: 'url("' + img.src + '")',
          })
          .addClass('lazyload-loaded');
      });
      $(e).addClass('loading');
      img.src = rename(src);
    }
    e.removeAttribute('data-src');
  },
};
pageLoaded(() => {
  lazyload.init();
});
